const propertyRulesQuery = `
  propertyRules {
    landlordLivesInHouse {
      icon
      locoKey
      landlordBirthday
      landlordGender
    }
    smokingAllowed {
      icon
      locoKey
      additionalInfo
    }
    petsAllowed {
      icon
      locoKey
      allowedTypes
      additionalInfo
      price
    }
    overnightGuests {
      icon
      locoKey
      additionalInfo
      price
    }
    couplesAllowed {
      icon
      locoKey
      additionalInfo
    }
    minimumAndMaximumAge {
      icon
      locoKey
      max
      min
    }
    tenantProfile {
      icon
      locoKey
    }
  }
  contractualPermissions {
    domiciliationAllowed {
      icon
      locoKey
      additionalInfo
    }
    newContractValidForScholarship {
      icon
      locoKey
      additionalInfo
    }
  }
  documentsPolicy {
    requiredDocumentation {
      documents
      additionalInfo
    }
  }
  moveInMoveOutPolicy {
    minimumNoticePeriod {
      days
      price
    } 
    moveInMoveOutSchedules {
      price
      ranges {
        days
        checkIn {
          from
          to
        }
        checkOut {
          from
          to
        }
      }
    }
  }
`;

const listingQuery = (children = '') => `
  listing {
    id
    adId
    title
    minStay
    maxStay
    stayRules {
      bookingTooEarlyDays
    }
    bookingConditions {
      securityDepositType
      securityDepositValue
      adminFeeType
      adminFeeValue
      hasVetting
      hasRentCollection
    }
    checked
    verificationDate
    hasOffer
    isBestChoice
    isSelect
    isBookable
    contractType
    cancellationPolicy
    hasOwnPhotos
    bookingAcceptanceMinDays
    bookingAcceptanceMaxDays
    refreshAvailabilitiesDate
    landlordRules
    offers {
      id
      discountType
      discountValue
      minStay
      maxStay
    }
    runner {
      firstName
      photoUrl
    }
    instantBooking {
      isEnabled
      rules {
        type
        params
      }
    }
    type
    ptype {
      title
      breadcrumbLabel
      url
    }
    availableFromDateIso8601
    unavailabilities {
      from
      to
    }
    availabilities {
      from
      to
    }
    moveInDatesRanges {
      from
      to
    }
    city
    cityId
    countryCode
    postalCode
    address
    area
    coords
    plan
    photos {
      floorplanList
      photoList (locale: $locale) {
        id
        caption
        verified
      }
      photo360List (locale: $locale) {
        id
        caption
      }
    }
    videos {
      embedUrl
      videoTranscription
      videoId
      name
      description
      thumbnailUrl
      uploadDate
    }
    features
    extraFeatures
    bills
    gender
    suitability
    restrictions
    pricing {
      price
      currencyLabel
      currencySymbol
      monthlyPrice {
        type
        minimumPrice
        fixedPrice
        pricesByMonth {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
      }
    }
    contents
    manuallyTranslatedLocales
    areaInfo {
      id
      slug
      limits {
        sw
        ne
      }
    }
    reviews {
      count
      ratingAverage
    }
    otherRooms(locale: $locale) {
      id
      checked
      currencyIsoCode
      firstAvailableDate
      isInstantBooking
      noSecurityDeposit
      isFavorite
      mainPhotoUrl
      displayPrice
      photoIds
      otherPropertyPhotoIds
      title
      type
      url
      hasOffer
      offers {
        discountType
        discountValue
      }
      allowsPermanentContract
      numberOfBathrooms
      isBestChoice
      plan
      cardTitle
      billsIncluded
    }
    roomsInApartment {
      id
      bedroomNumber
      checked
      price
      monthlyPrice {
        type
        minimumPrice
        fixedPrice
        pricesByMonth {
          jan
          feb
          mar
          apr
          may
          jun
          jul
          aug
          sep
          oct
          nov
          dec
        }
      }
      currency {
        symbol
        label
        iso
      }
      title
      longTitle
      description
      features
      firstAvailability {
        isoFormat
        stringFormat
      }
      mainPhoto
      photoUrls {
        homecardHidpi
        homecard
      }
      url
      contents
      floorplanReference
      allowsPermanentContract
    }
    m2
    propertyFeatures
    unitFeatures
    details {
      nBathrooms
      nBedrooms
    }
    landlordId
    allowsPermanentContract
    allowsTemporalContract
    contractDurationTypesAllowed
    landlordType
    landlordName
    hasHiddenFees
    landlordScoring {
      score
      totalBookingsClosed
    }
    ${children}
  }
`;

export const listingQueryWithPropertyRules = listingQuery(propertyRulesQuery);

export default listingQuery();
